// Keep in sync with the person_areas Postgres enum and the backend copy in
// supabase/functions/_shared/constants/sheriff-areas.ts.
export const ALL_SHERIFF_AREAS = [
  "Rc1 Deliveries",
  "Rc2 Deliveries",
  "Collections",
  "Sortation",
  "Depot",
  "Network",
  "Live Ops",
  "Driver Ops",
  "Driver Resourcing",
  "Dsp Managers",
  "Cx",
  "Fleet Team",
  "Hq",
  // Deprecated
  // "Customer Service",
  // "Driver Partnerships",
  // "Des",
] as const

export type SheriffArea = (typeof ALL_SHERIFF_AREAS)[number]

export const ALL_LOCATIONS = [
  "Bristol Node",
  "Central Depot",
  "Redditch Depot",
  "Silvertown Depot",
  "Hayes Depot",
  "South Node",
  "Brighton Node",
] as const

export type Location = (typeof ALL_LOCATIONS)[number]

export {
  ALL_SHERIFF_TYPES,
  OVERVIEW_SHERIFF_TYPES,
  type SheriffType,
} from "../../shared/sheriff-types.ts"

/**
 * Maximum allowed shift duration in hours.
 * Keep in sync with MAX_SHIFT_DURATION_HOURS in supabase/functions/shifts/shift-constants.ts
 */
export const MAX_SHIFT_DURATION_HOURS = 24

export {
  INVALID_UK_TIME_ERROR,
  SHIFT_START_IN_PAST_ERROR,
  SHIFT_START_PAST_TOLERANCE_MINUTES,
  UK_TIMEZONE,
  addDaysToDateString,
  blockInstants,
  eachDateInRange,
  isShiftStartInPast,
  ukDateFilterRange,
  ukDateOf,
  ukDayEnd,
  ukDayStart,
  ukTimeOf,
  ukToday,
  ukWallClockToInstant,
} from "../../shared/shift-timing.ts"
